export default {
  sui: {
    loading: {
      text: 'Chargement'
    },
    form: {
      more: 'Plus',
      zhankai: 'Développer',
      shouqi: 'Réduire',
      query: 'Rechercher',
      reset: 'Réinitialiser',
      add: 'Ajouter',
      update: 'Mettre à jour',
      delete: 'Supprimer',
      required: 'est requis',
      export: {
        export: 'Exporter',
        selectFormat: 'sélectionner le format',
        selectedRow: '{key} lignes sélectionnées',
        selectedTotal: '{key} lignes au total, exporter',
        line: 'ligne'
      },
      please: {
        input: 'entrez ',
        select: 'sélectionnez '
      },
      time: {
        start: 'heure de début',
        end: 'heure de fin',
        to: 'à'
      },
      date: {
        start: 'date de début',
        end: 'date de fin'
      },
      upload: {
        triggerText: 'télécharger'
      },
      expand: 'Développer',
      multiple: 'Multiple',
      cols_hide: 'Paramètres d\'en-tête'
    },
    table: {
      handle: 'Actions',
      sum: 'Somme',
      index: 'Index',
      zanwushuju: 'aucune donnée',
      queding: 'OK',
      quxiao: 'Annuler',
      lie: 'Colonne',
      yiyincang: 'Masqué',
      gong: 'Total'
    },
    tableEdit: {
      tip1: 'Les données sont toujours en cours d\'édition et ne peuvent pas être enregistrées !',
      tip2: 'Êtes-vous sûr de vouloir supprimer les données ?',
      baocun: 'Enregistrer',
      chongzhi: 'Réinitialiser',
      xinzeng: 'ajouter',
      guanbituozhuai: 'fermer le glisser-déposer',
      kaiqituozhuai: 'ouvrir le glisser-déposer',
      caozuo: 'Actions',
      queren: 'OK',
      bianji: 'Modifier',
      shanchu: 'Supprimer',
      tishi: 'conseils'
    },
    list: {
      yi_xuan_ze: 'sélectionné',
      tiao: 'éléments',
      gong: 'total',
      mei_you_geng_duo: 'pas plus',
      zan_wu_shu_ju: 'Aucune donnée n\'est encore sélectionnée'
    },
    bond: {
      zheng_quan_dai_ma: 'code d\'obligation',
      zheng_quan_ming_cheng: 'nom d\'obligation',
      zan_wu_shu_ju: 'aucune donnée',
      qu_xiao_qing_qiu: 'la demande a été annulée'
    },
    dialog: {
      ok: 'OK',
      cancel: 'Annuler'
    },
    page: {
      add: {
        success: 'ajout de [{key}] réussi'
      },
      delete: {
        title: '{key}-suppression',
        confirm: 'confirmer la suppression de [{key}] ?',
        success: 'suppression de [{key}] réussie'
      },
      update: {
        success: 'mise à jour de [{key}] réussie',
        noChange: 'données non modifiées, non enregistrées'
      }
    },
    tablePage: {
      export: {
        tip1: 'veuillez entrer le bon numéro de ligne',
        tip2: 'type d\'exportation',
        tip3: 'sélectionner',
        tip4: 'exporter comme',
        tip5: 'veuillez sélectionner le type de fichier d\'exportation',
        lie: 'colonne',
        hang: 'ligne',
        shi: 'oui',
        fou: 'non',
        daochu: 'Exporter',
        wancheng: 'Confirmer',
        quxiao: 'Annuler',
        gong: 'Total',
        type1: 'exportation séquentielle',
        type2: 'exportation par sélection manuelle',
        daochu_geshi: 'type de fichier d\'exportation'
      }
    },
    editlist: {
      caozuo: 'Actions',
      shanchu: 'Supprimer',
      xinzeng: 'Ajouter'
    },
    upload: {
      tip1: 'appuyez sur la touche de suppression pour supprimer'
    },
    uploadPro: {
      tip1: 'Connexion Websocket perdue, tentative de reconnexion',
      tip2: 'connexion interrompue'
    },
    select: {
      jiazaizhong: 'chargement',
      wupipeishuju: 'aucune donnée correspondante',
      wushuju: 'aucune donnée',
      quanxuan: 'tout sélectionner',
      fanxuan: 'inverser'
    },
    transfer: {
      tip1: 'rechercher',
      liebiao1: 'Liste 1',
      liebiao2: 'Liste 2'
    },
    treeGrid: {
      caozuolan: 'Actions'
    },
    empty: {
      zanwuneirong: 'aucune donnée'
    },
    valid: {
      char: 'caractère',
      len1: 'veuillez entrer {p1} ',
      len2: 'veuillez entrer de {p1} à {p2} ',
      num: 'caractère numérique',
      pInt: 'entier positif',
      npInt: 'entier non positif',
      nInt: 'entier négatif',
      nNInt: 'entier non négatif',
      int: 'entier',
      pFNum: 'nombre flottant positif',
      nFNum: 'nombre flottant négatif',
      num_: 'caractère numérique(-,_)',
      en: 'caractère anglais',
      en_: 'caractère anglais(-,_)',
      ch: 'caractère chinois',
      ch_: 'caractère chinois(-,_)',
      nch: 'caractère non chinois',
      numEn: 'caractère numérique ou anglais',
      numEn_: 'caractère numérique ou anglais(-,_)',
      chEnNum: 'caractère numérique, anglais ou chinois',
      chEnNum_: 'caractère numérique, anglais ou chinois(-,_)',
      phone: 'numéro de téléphone',
      email: 'email',
      idcard: 'carte d\'identité',
      url: 'URL',
      reg: 'veuillez entrer un ',
      version: 'balise de version',
      uri: 'uri',
      datasource: 'source de données',
      intRegion: 'entier de {p1} à {p2}',
      floatRegion: 'nombre flottant de {p1} à {p2}'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: 'Plage de temps absolue',
      xiang_dui_shi_jian_fan_wei: 'Plage de temps relative',
      kai_shi_shi_jian: 'Heure de début',
      jie_su_shi_jian: 'Heure de fin',
      zui_jin_wu_fen_zhong: 'Dernières 5 minutes',
      zui_jin_shi_wu_fen_zhong: 'Dernières 15 minutes',
      zui_jin_san_shi_fen_zhong: 'Dernières 30 minutes',
      zui_jin_yi_xiao_shi: 'Dernière heure',
      zui_jin_san_xiao_shi: 'Dernières 3 heures',
      zui_jin_liu_xiao_shi: 'Dernières 6 heures',
      zui_jin_shi_er_xiao_shi: 'Dernières 12 heures',
      zui_jin_er_shi_si_xiao_shi: 'Dernières 24 heures',
      zui_jin_liang_tian: 'Derniers 2 jours',
      zui_jin_qi_tian: 'Derniers 7 jours',
      zui_jin_san_shi_tian: 'Derniers 30 jours'
    },
    bookmark: {
      biao_ti: 'favori',
      xin_zeng_shu_qian: 'ajouter un favori',
      ming_cheng: 'nom',
      fu_gai: 'écraser',
      chong_ming_ming: 'renommer',
      shan_chu: 'supprimer',
      ming_cheng_xiu_gai_cheng_gong: 'Nom modifié avec succès',
      xin_zeng: 'ajouter',
      shan_chu_ti_shi: 'confirmer la suppression de [{name}] ?',
      shan_chu_cheng_gong: 'supprimé avec succès',
      xin_zeng_cheng_gong: 'Favori ajouté avec succès !',
      tian_jia_ji_lu: 'ajouter à l\'historique',
      gong: 'total',
      tiao: 'éléments',
      bao_cun: 'enregistrer',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: 'Veuillez confirmer que l\'enregistrement est en cours d\'ajout'
    },
    messageBox: {
      qing_shuru_yanzhengma: 'Veuillez entrer le code de vérification',
      yanzhengma_bu_zhengque: 'Code de vérification incorrect'
    },
    jsonEditor: {
      fuzhi: 'copier'
    },
    cron: {
      second: 'seconde',
      minute: 'minute',
      hour: 'heure',
      day: 'jour',
      month: 'mois',
      week: 'semaine',
      year: 'année',
      cron_biaodashi_ziduan: 'Champ d\'expression Cron',
      hanhua_fanyi: 'Traduction en français',
      chongzhi: 'Réinitialiser',
      single: 'chaque ',
      mei_nian: 'chaque année',
      mei_yue: 'chaque mois',
      mei_ri: 'chaque jour',
      mei_tian: 'chaque jour',
      mei_shi: 'chaque heure',
      xiaoshi: 'heure',
      mei_fenzhong: 'chaque minute',
      mei_miao: 'chaque seconde',
      mei_zhou: 'chaque semaine',
      cong: 'de',
      yue_qi_mei_ge: 'chaque mois',
      ri_qi_mei_ge: 'chaque jour',
      shi_qi_mei_ge: 'chaque heure',
      fenzhong_qi_mei_ge: 'chaque minute',
      miao_qi_mei_ge: 'chaque seconde',
      zuihou_yitian: 'dernier jour',
      zhi: 'à',
      cong_zhou: 'de la semaine',
      zhi_zhou: 'à la semaine',
      qi_meige: 'chaque',
      tian_zhixingyici: ' fois par jour',
      xiaoshi_zhixingyici: ' fois par heure',
      yue_zhixingyici: ' fois par mois',
      zhixingyici: ' exécuter une fois',
      ben_yue_di: 'fin de ce mois',
      ben_yue: 'ce mois',
      xinqi: 'semaine',
      benyue_zuihou_yige_xingqi: 'Dernière semaine du mois',
      buzhiding: 'Non spécifié',
      zhouqi_cong: 'Cycle de',
      xunhuan_cong: 'Boucle de',
      tip1: 'chaque jour',
      tip2: 'le jour ouvrable le plus proche',
      tip3: 'commencer, chaque heure ',
      tip4: 'commencer, chaque mois',
      tip5: 'jour de la semaine',
      benyue_zuihou_yitian: 'Dernier jour du mois',
      zhiding: 'Spécifier',
      kaishi: 'commencer',
      kaishi_mei: 'commencer chaque',
      benyue: 'ce mois',
      mei: 'chaque ',
      zhixing: 'exécuter',
      zhouqi: 'Cycle',
      di: 'Non',
      mess1: 'La date et la semaine ne peuvent pas être "non spécifiées" en même temps',
      mess2: 'L\'un des jours et des semaines doit être "non spécifié"',
      zhouri: 'Dimanche',
      zhouyi: 'Lundi',
      zhouer: 'Mardi',
      zhousan: 'Mercredi',
      zhousi: 'Jeudi',
      zhouwu: 'Vendredi',
      zhouliu: 'Samedi'
    },
    treeGraph: {
      fangda: 'Agrandir',
      suoxiao: 'Réduire',
      shuaxin: 'Actualiser'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/fr-FR.js